import { Button, Col, Modal, Row, message } from "antd";
import { useSearchParams } from "react-router-dom";
import FilterPrivilege from "./filter-privilege";
import FilterDivision from "./filter-division";
import API from "../../../../services/api-request";
import { useState } from "react";
import FilterDepartement from "./filter-departement";
import UserManualButton from "../../../../components/UserManualButton";

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const onClear = (value) => props.onClear(value);

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);

    API.Post(`control-list/update`)
      .then((result) => {
        setOpen(false);
        setConfirmLoading(false);
        message.success("Access Control List has been saved");
        props.onClear(result);
      })
      .catch((err) => {
        message.info("Failed Save Access Control List");
        console.error(err);
      });
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <>
      {/* <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "18px" }}
        gutter={[8, 8]}
      > */}
      <Col lg={16} xs={24}>
        <Row gutter={[8, 8]} align={"middle"}>
          <Col lg={6} md={6} sm={12} xs={24}>
            <FilterPrivilege
              value={parseInt(searchParams.get("id_privilege")) ?? null}
              onChange={(e) => updateSearchParam("id_privilege", e ?? null)}
            />
          </Col>
          <Col lg={6} md={6} sm={12} xs={24}>
            <div style={{ width: "fit-content" }}>
              <UserManualButton />
            </div>
          </Col>
          {/* <Col lg={6} md={6} sm={12} xs={24}>
            <FilterDepartement
              value={parseInt(searchParams.get("id_department")) || null}
              onChange={(e) => updateSearchParam("id_department", e || null)}
            />
          </Col>
          <Col lg={6} md={6} sm={12} xs={24}>
            <FilterDivision
              value={parseInt(searchParams.get("id_division")) || null}
              onChange={(e) => updateSearchParam("id_division", e || null)}
            />
          </Col> */}
        </Row>
      </Col>

      <Modal
        title="Update Access Control List"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>Are you sure Update Access Control List?</p>
      </Modal>
    </>
  );
};

export default FilterMenu;
